var map = {
	"./calendar.svg": 342,
	"./car.svg": 25212,
	"./checkbox.svg": 33915,
	"./computer.svg": 5113,
	"./control.svg": 72771,
	"./correct.svg": 71459,
	"./dirt.svg": 40780,
	"./dokument.svg": 9494,
	"./drops.svg": 98502,
	"./engine.svg": 98452,
	"./extinguisher.svg": 18489,
	"./fill.svg": 56060,
	"./glass.svg": 18443,
	"./gloss.svg": 59945,
	"./interior.svg": 28761,
	"./laboratory.svg": 54640,
	"./layers.svg": 86410,
	"./lights.svg": 56545,
	"./photo.svg": 84283,
	"./plastics.svg": 7429,
	"./pressure.svg": 1674,
	"./protect.svg": 43945,
	"./service.svg": 40693,
	"./speed.svg": 70325,
	"./thift.svg": 66560,
	"./tire.svg": 330,
	"./wash.svg": 90472,
	"./washing.svg": 75310,
	"./wax.svg": 59982,
	"./wind.svg": 7069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20596;